export const dataLayerStyles = {
  delineated_fields: {
    text: 'Delineated Fields',
    backgroundColor: '#d4edda',
    color: '#155724',
    borderRadius: '12px',
    padding: '4px 10px',
    fontSize: '12px',
  },
  dr_images: {
    text: 'S2 DR Imagery',
    backgroundColor: '#fff3cd',
    color: '#856404',
    borderRadius: '12px',
    padding: '4px 10px',
    fontSize: '12px',
  },
  timeseries: {
    text: 'SE-2 Time-Series',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderRadius: '12px',
    padding: '4px 10px',
    fontSize: '12px',
  },
  // Add more mappings as needed
};

export const apiLayer = {
  location: {
    text: 'Location',
  },
  bbox: {
    text: 'Bbox',
  },
  fdCoverage_highres: {
    text: 'High-resolution',
  },
  fdCoverage_lowres: {
    text: 'Low-resolution',
  },
  fdCoverage: {
    text: 'Field Coverage',
  },
  'dr-imagery': {
    text: 'DR Coverage',
  },
};
